import React from "react";
import { Editor } from "@tiptap/react";

import WindowOutlinedIcon from "@mui/icons-material/WindowOutlined";

import { ButtonProps, Button } from "containers/Tiptap/components/tiptap-ui-primitive/button";

import { useTiptapEditor } from "containers/Tiptap/hooks/use-tiptap-editor";
import { RISK_MATRIX_CONSTANTS } from "containers/Tiptap/components/tiptap-node/risk-assessments-node/constants";

export interface RiskMatrixButtonProps extends ButtonProps {
  editor?: Editor | null;
  onAdded?: () => void;
}

export function addRiskMatrix(editor: Editor | null): void {
  if (!editor) return;

  try {
    editor
      .chain()
      .focus()
      .setRiskMatrixNode({
        defaultRows: RISK_MATRIX_CONSTANTS.DEFAULT_ROWS,
        defaultColumns: RISK_MATRIX_CONSTANTS.DEFAULT_COLUMNS,
        defaultImpactLabels: RISK_MATRIX_CONSTANTS.DEFAULT_IMPACT_LABELS,
        defaultLikelihoodLabels: RISK_MATRIX_CONSTANTS.DEFAULT_LIKELIHOOD_LABELS,
        editable: true,
      })
      .run();
  } catch (error) {
    console.error("Failed to add risk matrix:", error);
  }
}

export const RiskMatrixButton: React.FC<RiskMatrixButtonProps> = ({
  editor: providedEditor,
  onAdded,
  ...buttonProps
}) => {
  const { editor } = useTiptapEditor(providedEditor);

  const handleClick = (): void => {
    addRiskMatrix(editor);
    onAdded?.();
  };

  if (!editor || !editor.isEditable) {
    return null;
  }

  return (
    <Button {...buttonProps} onClick={handleClick} data-style="ghost">
      <WindowOutlinedIcon />
    </Button>
  );
};
